<template>
  <div id="header-details"
       class="header-details">
    <div :style="getBackgroundImage"
         class="principal-images">
      <div class="container-texts-principal">
        <div v-if="type === 'event'"
             class="container-price-principal">
          <p v-if="details.price"> {{ $t('headerDetails.desde') }}
            <span v-if="details.currency"> {{ $n(details.price, { key: 'currency', currency: details.currency }) }}</span>
          </p>
        </div>
        <div class="container-title-principal">
          <h1 v-if="details.name || details.title">{{ details.name || details.title }}
            <span v-if="type === 'event'">{{ details.subtitle }}</span>
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    details: {
      type: Object,
      default: function() {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    },
  },
  data: () => ({
    initialUrl: process.env.VUE_APP_INITIAL_URL,
    buyButton: process.env.VUE_APP_BUY_BUTTON,
    postponedPaymentUrl: process.env.VUE_APP_POSTPONED_PAYMENT_URL,
  }),
  computed: {
    getBackgroundImage() {
      return `background-image: linear-gradient(rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.50)), url(${
        this.details.thumbnails
          ? this.details.thumbnails.l_hor_dt
          : this.details.image_url
      })`
    }
  },
  methods: {
    scrollTo: function(id) {
      var element = document.getElementById(id)
      var options = {
        offset: -150
      }
      this.$scrollTo(element, 500, options)
    }
  }
}
</script>

<style lang="scss">
@import './header-details.sass';
.btn-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
@media(min-width: 767px) {
  .btn-container {
    display: flex;
    justify-content: center;
    flex-direction: row;
  }
}
</style>
